__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "oceantech-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@oceantech/oceantech-ui", "0.9.13", () => (Promise.all([__webpack_require__.e(9547), __webpack_require__.e(8395), __webpack_require__.e(5226), __webpack_require__.e(6989), __webpack_require__.e(8748), __webpack_require__.e(8692), __webpack_require__.e(7026), __webpack_require__.e(7745), __webpack_require__.e(3292), __webpack_require__.e(7565), __webpack_require__.e(964), __webpack_require__.e(2177), __webpack_require__.e(6785), __webpack_require__.e(2428), __webpack_require__.e(9954), __webpack_require__.e(863), __webpack_require__.e(1909), __webpack_require__.e(6871), __webpack_require__.e(5219), __webpack_require__.e(2687), __webpack_require__.e(9995)]).then(() => (() => (__webpack_require__(56785))))));
			register("axios", "0.26.1", () => (__webpack_require__.e(3422).then(() => (() => (__webpack_require__(73422))))));
			register("formik", "2.2.9", () => (Promise.all([__webpack_require__.e(1746), __webpack_require__.e(2428)]).then(() => (() => (__webpack_require__(1746))))));
			register("react-dom", "18.0.0", () => (Promise.all([__webpack_require__.e(5957), __webpack_require__.e(2428)]).then(() => (() => (__webpack_require__(45957))))));
			register("react-intl", "5.25.0", () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(6138), __webpack_require__.e(2428)]).then(() => (() => (__webpack_require__(66138))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(6696), __webpack_require__.e(2428), __webpack_require__.e(1909)]).then(() => (() => (__webpack_require__(86696))))));
			register("react-router", "6.3.0", () => (Promise.all([__webpack_require__.e(8857), __webpack_require__.e(2428)]).then(() => (() => (__webpack_require__(68857))))));
			register("react", "18.0.0", () => (__webpack_require__.e(8036).then(() => (() => (__webpack_require__(8036))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};